export default "__VITE_ASSET__38fce5c9__"